// Virus scans of attachments that are still running, checked from the reader.
import type { ScanResult } from "../shared/types";
import { api } from "./api";

type ScanListener = (scans: Map<string, ScanResult>) => void;
/** One poll per message for its pending scans, however many of its files are waiting. */
const scanPolls = new Map<string, { listeners: Set<ScanListener>; timer: number }>();

/** Calls back with the message's scan results every 15 s (for 10 minutes) while it's shown. */
export const watchScans = (messageId: string, listener: ScanListener) => {
  let poll = scanPolls.get(messageId);
  if (!poll) {
    const listeners = new Set<ScanListener>();
    let checks = 0;
    const timer = window.setInterval(async () => {
      // A tab in the background doesn't need the answer yet.
      if (document.visibilityState !== "visible") return;
      checks += 1;
      if (checks > 40) {
        window.clearInterval(timer);
        scanPolls.delete(messageId);
      }
      const found = await api
        .get<{ scans: Record<string, ScanResult> }>(`/messages/${messageId}/scans`)
        .catch(() => null);
      if (!found) return;
      const scans = new Map(Object.entries(found.scans));
      for (const notify of listeners) notify(scans);
    }, 15_000);
    poll = { listeners, timer };
    scanPolls.set(messageId, poll);
  }
  const current = poll;
  current.listeners.add(listener);
  return () => {
    current.listeners.delete(listener);
    if (current.listeners.size === 0) {
      window.clearInterval(current.timer);
      if (scanPolls.get(messageId) === current) scanPolls.delete(messageId);
    }
  };
};
